"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rivergaro": {
    "a540375d": [{
      "hkey": "25039f62",
      "slug": "ancarano-pieve-dugliara",
      "name": "Ancarano-Pieve Dugliara",
      "primary": true,
      "skipSearch": false
    }],
    "ancarano": [{
      "hkey": "25039f62",
      "slug": "ancarano-pieve-dugliara",
      "name": "Ancarano-Pieve Dugliara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1639fdd2": [{
      "hkey": "25039f62",
      "slug": "ancarano-pieve-dugliara",
      "name": "Ancarano-Pieve Dugliara",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-dugliara": [{
      "hkey": "25039f62",
      "slug": "ancarano-pieve-dugliara",
      "name": "Ancarano-Pieve Dugliara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rivergaro"
    }]
  }
};
exports["default"] = _default;